import Banner from './Banner';

export { Banner };
export default Banner;
